type Props = {
  value: boolean;
  onChange: (next: boolean) => void;
};

export function AvailabilityToggle({ value, onChange }: Props) {
  return (
    <label className="poca-toggle">
      <input
        type="checkbox"
        className="poca-toggle__input"
        checked={value}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="poca-toggle__track" aria-hidden="true">
        <span className="poca-toggle__thumb" />
      </span>
      <span className="poca-toggle__label">In stock only</span>
    </label>
  );
}
